module.exports = __webpack_public_path__ + "img/resource-gold.c97a312b.png";